import styled from 'styled-components';

import { BindingCreator } from '@dreryk/react-common';
import { AutoLayout } from '@dreryk/react-components';

import { PatientAddressFormBean } from '../../../entitlementStatements/create/form/PatientEntitlementStatementCreateForm';
import { FlatField } from '../../FlatField';
import { HouseField } from '../../HouseField';
import { StreetField } from '../../StreetField';
import { TownField } from '../../TownField';
import { PostalCodeField } from '../PostalCodeField';

const NARROW_INPUT_WIDTH = 126;
const FIRST_COLUMN_WIDTH = 368;
const COLUMN_GAP = 36;

const StyledWideInput = styled.div`
   width: ${FIRST_COLUMN_WIDTH}px;
`;
StyledWideInput.displayName = 'StyledWideInput';

const StyledNarrowInput = styled.div`
   width: ${NARROW_INPUT_WIDTH}px;
`;
StyledNarrowInput.displayName = 'StyledNarrowInput';

type AddressSectionProps = {
   readonly register: BindingCreator<PatientAddressFormBean>;
   readonly prefix?: string;
};

export const AddressSection = (props: AddressSectionProps): JSX.Element => {
   const { register, prefix } = props;

   const fieldPrefix = prefix ?? '';

   return (
      <>
         <AutoLayout as={'div'} $direction={'horizontal'} $spacing={COLUMN_GAP} $horizontalResizing={'fill'}>
            <StyledWideInput>
               <AutoLayout
                  as={StreetField}
                  prefix={fieldPrefix}
                  name={'street'}
                  register={register}
                  required
                  $horizontalResizing={FIRST_COLUMN_WIDTH}
               />
            </StyledWideInput>
            <StyledNarrowInput>
               <AutoLayout
                  as={HouseField}
                  prefix={fieldPrefix}
                  name={'house'}
                  register={register}
                  required
                  $horizontalResizing={NARROW_INPUT_WIDTH}
               />
            </StyledNarrowInput>
            <StyledNarrowInput>
               <AutoLayout
                  as={FlatField}
                  prefix={fieldPrefix}
                  name={'flat'}
                  register={register}
                  required
                  $horizontalResizing={NARROW_INPUT_WIDTH}
               />
            </StyledNarrowInput>
         </AutoLayout>
         <AutoLayout as={'div'} $direction={'horizontal'} $spacing={COLUMN_GAP} $horizontalResizing={'fill'}>
            <StyledWideInput>
               <AutoLayout
                  as={TownField}
                  prefix={fieldPrefix}
                  name={'town'}
                  register={register}
                  required
                  $horizontalResizing={FIRST_COLUMN_WIDTH}
               />
            </StyledWideInput>
            <StyledNarrowInput>
               <AutoLayout
                  as={PostalCodeField}
                  prefix={fieldPrefix}
                  name={'postcode'}
                  register={register}
                  required
                  $horizontalResizing={NARROW_INPUT_WIDTH}
               />
            </StyledNarrowInput>
         </AutoLayout>
      </>
   );
};
